module.exports = __webpack_public_path__ + "static/rf-circle-mark-bc73ca5dd9ff97493121c26883ffdb36.png";